import { FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { NotificationCircle } from 'baseui/badge';
import { Button } from 'baseui/button';
import { Drawer } from 'baseui/drawer';
import { useRecoilValue } from 'recoil';
import {
  GPT_DETAIL_PAGE,
  LIVE_STATUS_PAGE,
  NOTIFICATION_PAGE,
  SECONDARIES_PAGE,
  TRACKING_PAGE,
} from '../../constants/app';
import { useDrawer } from '../../hooks/useDrawer';
import { useStyles } from '../../hooks/useStyles';
import { isAllWorkspacesSelect, pageState } from '../../storage/app';
import { unreadNotificationsCountState } from '../../storage/notifications';
import { LiveStatusList } from '../liveStatus/LiveStatusList';
import { NotificationList } from '../notifications/NotificationList';
import NavbarWrapper from '../ui/NavbarWrapper';
import { StyledTooltip } from '../ui/StyledTooltip';
import { UserMenu } from './UserMenu';

export function Navbar() {
  const { theme } = useStyles();
  const page = useRecoilValue(pageState);
  const { openDrawer, closeDrawer, showDrawer } = useDrawer();
  const { openDrawer: openLiveStatus, closeDrawer: closeLiveStatus, showDrawer: showLiveStatus } = useDrawer();
  const unreadNotificationsCount = useRecoilValue(unreadNotificationsCountState);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);

  return (
    <NavbarWrapper>
      <>
        {page !== TRACKING_PAGE.id &&
          page !== SECONDARIES_PAGE.id &&
          page !== NOTIFICATION_PAGE.id &&
          page !== LIVE_STATUS_PAGE.id &&
          page !== GPT_DETAIL_PAGE.id && (
            <>
              <FlexRow gap={theme.sizing.scale0}>
                {!isAllWorkspacesSelected && (
                  <>
                    <StyledTooltip
                      content={'Prevención de riesgos'}
                      showArrow={false}
                    >
                      <Button
                        size="compact"
                        shape="square"
                        onClick={openLiveStatus}
                        kind="tertiary"
                      >
                        <MaterialIcon name="warning" />
                      </Button>
                    </StyledTooltip>
                    <NotificationCircle
                      content={unreadNotificationsCount}
                      color="warning"
                      placement="topRight"
                      horizontalOffset="0px"
                      verticalOffset="-3px"
                      hidden={!unreadNotificationsCount}
                      overrides={{
                        Badge: {
                          style: () => ({
                            fontSize: '9px',
                            borderRadius: '16px',
                            width: '16px',
                            height: '16px',
                            lineHeight: '13px',
                          }),
                        },
                      }}
                    >
                      <StyledTooltip
                        content={'Mostrar notificaciones'}
                        showArrow={false}
                      >
                        <Button
                          size="compact"
                          shape="square"
                          onClick={openDrawer}
                          kind="tertiary"
                        >
                          <MaterialIcon name={'notifications'} />
                        </Button>
                      </StyledTooltip>
                    </NotificationCircle>
                  </>
                )}
                <UserMenu />
              </FlexRow>
              <Drawer
                isOpen={showDrawer}
                closeable={false}
                onBackdropClick={closeDrawer}
                overrides={{
                  DrawerBody: {
                    style: {
                      marginTop: 0,
                      marginRight: 0,
                      marginBottom: 0,
                      marginLeft: 0,
                    },
                  },
                }}
              >
                <NotificationList onClose={closeDrawer} />
              </Drawer>
              <Drawer
                isOpen={showLiveStatus}
                closeable={false}
                onBackdropClick={closeLiveStatus}
                overrides={{
                  DrawerContainer: {
                    style: {
                      width: '400px',
                    },
                  },
                  DrawerBody: {
                    style: {
                      marginTop: 0,
                      marginRight: 0,
                      marginBottom: 0,
                      marginLeft: 0,
                    },
                  },
                }}
              >
                <LiveStatusList />
              </Drawer>
            </>
          )}
      </>
    </NavbarWrapper>
  );
}
